import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "32",
      height: "32",
      fill: "currentColor",
      "fill-opacity": ".18",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25.607 21.152 19 8.796c-1.28-2.394-4.72-2.394-6 0L6.393 21.152C5.219 23.348 6.813 26 9.308 26h13.384c2.494 0 4.089-2.653 2.915-4.848M15.25 14a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0zm.77 8a1.005 1.005 0 0 1-1.005-1c0-.552.443-1 .995-1h.01a1 1 0 1 1 0 2"
    }, null, -1)
  ])))
}
export default { render: render }